import React from 'react'
import copy from 'copy-to-clipboard'
import classnames from 'classnames'
import message from 'antd/lib/message'

import config from 'config'
import { analytics, constants } from 'helpers'
import cls from './EventCard.module.scss'
import clipIcon from 'assets/icons/clip.svg'
import TicketBreakdown from '../TicketBreakdown'
import EventDetails from '../EventDetails'

const DetailsWrapper = ({ className, children }) => (
  <div className={classnames('mb-4 px-2', className)}>
    <div className="bg-gray-300 bg-opacity-30 rounded-lg">{children}</div>
  </div>
)

const {
  EVENT_CONSTANTS: {
    STATUS: { CREATED, UPDATED, STARTED },
    PLACEHOLDER_IMG,
  },
} = constants

const EventCard = ({ clickedEventCard, event, user }) => {
  const eventId = event.slug
  const inviteEventLink = `${config.main_domain}/events/${eventId}`
  const canShowTicketsAndInviteLink = [CREATED, STARTED, UPDATED].includes(event.status)

  return (
    <div data-cardeventid={eventId} className={cls.eventDetail}>
      <div onClick={clickedEventCard}>
        <div
          className={cls.cover}
          style={{ backgroundImage: `url(${event.image}), url(${PLACEHOLDER_IMG})` }}
        />
        <DetailsWrapper className="mt-4">
          <EventDetails
            event={event}
            user={user}
            eventLink={inviteEventLink}
            classNames={{ td: 'border-white' }}
          />
        </DetailsWrapper>
        <DetailsWrapper>
          <TicketBreakdown tickets={event.tickets} />
        </DetailsWrapper>
      </div>
      {canShowTicketsAndInviteLink && (
        <div className={cls.clipBtnContainer}>
          <button
            className={cls.copyLinkBtn}
            onClick={() => {
              copy(inviteEventLink)
              message.success('Copied to Clipboard', 2.5)
              analytics.segmentTrack('Host Copies Their Event Invite Link', {
                eventId: eventId,
              })
            }}
          >
            <img src={clipIcon} alt="clip" />
            <p className={cls.styleAndWeight}>Copy invite link</p>
          </button>
        </div>
      )}
    </div>
  )
}

export default EventCard
